// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ScrollTo } from "react-scroll-to";
import _ from 'lodash';

import type { TRoundWithMatches } from '../../modules/types';

import * as selectors from '../../modules/selectors';

import JsonFetcher from '../utils/JsonFetcher';
import ArrowLeft from '../Icons/ArrowLeft';
import ArrowRight from '../Icons/ArrowRight';
import { getActualMatch } from '../../helpers/rounds';
import RoundList from './RoundList';


const Container = styled.div`
	background: #F5F4F5;
	height: 70px;
`;

const InnerContainer = styled.div`
	display: flex;
	height: 100%;
	justify-content: space-between;
`;

const ArrowButton = styled.button.attrs({
	type: 'button'
})`
	background: #00ff9a;
	border: 0 none;
	margin: 0;
	padding: 0;

	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 20px;
	width: 30px;
	flex: 0 0 30px;
	z-index: 1;

	${({ hide_shadow, right }) => !hide_shadow && `
		box-shadow: ${right ? '-22px' : '22px'} 0px 30px -13px rgba(0,0,0,0.75);
	`}
`;

const List = styled.div`
    position: relative;
	flex: 1 10 auto;
	display: flex;
	overflow-x: hidden;
`;

type Props = {
	actual_round: TRoundWithMatches,
	rounds_with_matches: Array<TRoundWithMatches>
}

const getScrollDistance = container_width => container_width / 4 * 3;

class MatchCentreBarComponent extends React.PureComponent<Props> {
	componentDidMount() {
		this.positionListScroll();
	}

	componentDidUpdate() {
		this.positionListScroll();
	}

	ListRef = React.createRef();

	get ListRefElement() {
		return this.ListRef.current;
	}

	get actual_match() {
		const { actual_round } = this.props;

		if (actual_round) {
			return getActualMatch(actual_round.matches);
		}

		return null;
	}

	get actual_round_panel() {
		const { actual_round } = this.props;

		if (actual_round && actual_round.id) {
			return window.document.getElementById(`R-${actual_round.id}`);
		}
	}

	get actual_match_panel() {
		if (this.actual_match) {
			return window.document.getElementById(`M-${this.actual_match.id}`) || null;
		}
	}

	get last_match() {
		const { actual_round } = this.props;
		if (actual_round && actual_round.matches) {
			return _.last(actual_round.matches);
		}
	}

	get last_match_panel() {
		if (this.last_match) {
			return window.document.getElementById(`M-${this.last_match.id}`);
		}
	}

	get is_ready_to_set_scroll_position() {
		const { actual_round } = this.props;

		return actual_round &&
			this.actual_match &&
			this.actual_round_panel &&
			this.actual_match_panel &&
			this.actual_match_panel.offsetLeft &&
			this.actual_match_panel.offsetWidth &&
			this.ListRefElement;
	}

	get container_width() {
		if (this.ListRefElement) {
			return this.ListRefElement.offsetWidth;
		}
	}

	get actual_round_end_offset_position() {
		if (this.last_match_panel && this.container_width) {
			return (this.last_match_panel.offsetLeft + this.last_match_panel.offsetWidth) -
				this.container_width;
		}
	}

	positionListScroll() {
		if (this.is_ready_to_set_scroll_position) {
			const ideal_scroll_position = // $FlowFixMe
				this.actual_match_panel.offsetLeft - this.actual_match_panel.offsetWidth;

			const is_ideal_past_end_of_round =
				ideal_scroll_position > this.actual_round_end_offset_position;

			const scroll_position = is_ideal_past_end_of_round ?
				this.actual_round_end_offset_position : ideal_scroll_position;

			// $FlowFixMe
			this.ListRefElement.scrollLeft = scroll_position;
		}
	}

	render() {
		const { rounds_with_matches } = this.props;
		// if(true) {
		// 	return (
		// 		<div></div>
		// 	);
		// }

		return (
			<Container>
				<InnerContainer>
					<JsonFetcher fetch={['rounds', 'squads']} />

					<ScrollTo>
						{({ scrollTo }) => (
							<ArrowButton
								onClick={() => scrollTo({
									ref: this.ListRef,
									x: this.ListRefElement ? this.ListRefElement.scrollLeft -
										getScrollDistance(this.ListRefElement.offsetWidth): 0,
									smooth: true
								})}
							>
								<ArrowLeft />
							</ArrowButton>
						)}
					</ScrollTo>

					<List innerRef={this.ListRef}>
						{Array.isArray(rounds_with_matches) && rounds_with_matches.map(round => (
							<RoundList key={round.id} round={round} />
						))}
					</List>

					<ScrollTo>
						{({ scrollTo }) => (
							<ArrowButton
								right
								onClick={() => scrollTo({
									ref: this.ListRef,
									x: this.ListRefElement ? this.ListRefElement.scrollLeft +
										getScrollDistance(this.ListRefElement.offsetWidth): 0,
									smooth: true
								})}
							>
								<ArrowRight />
							</ArrowButton>
						)}
					</ScrollTo>
				</InnerContainer>
			</Container>
		);
	}
}

const mapStateToProps = state => ({
	actual_round: selectors.rounds.getActualRound(state),
	rounds_with_matches: selectors.rounds.getRoundsWithMatches(state)
});

export const MatchCentreBar = connect(mapStateToProps)(MatchCentreBarComponent);

export default MatchCentreBar;


// WEBPACK FOOTER //
// ./src/components/MatchCentreBar/index.js